import { render, staticRenderFns } from "./AssDetail.vue?vue&type=template&id=39b2d9c3&scoped=true"
import script from "./AssDetail.vue?vue&type=script&lang=js"
export * from "./AssDetail.vue?vue&type=script&lang=js"
import style0 from "./AssDetail.vue?vue&type=style&index=0&id=39b2d9c3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b2d9c3",
  null
  
)

export default component.exports